import React from "react";
import Routes from "../../Routes";
import Header from "./header";
import Footer from "./footer";

export default function Layout(props) {
  return (
    <>
      {window.location.href.indexOf('Help') < 0 ?
        <>
          <div className='main-container'>
            <Header print={false} />
            <div className='pb-6'>
              <Routes />
            </div>
          </div>
          <Footer />
        </> :
        <div className='pb-0 help-container'>
          <Routes />
        </div>
      }
    </>
  );
}
